import { MrNavigationOverlay } from './navigation/mr-navigation-overlay';

class MrOfferOverlay extends MrNavigationOverlay {}

customElements.define( 'mr-offer-overlay', MrOfferOverlay );
